module.exports = __webpack_public_path__ + "static/media/appStoreDe.6ea74e88.svg";